"use client";

import { RichText } from "@payloadcms/richtext-lexical/react";
import { CircleHelp } from "lucide-react";
import { Link } from "next-view-transitions";

import type { Section13Block } from "~/lib/types/payload";

import { Button } from "~/lib/shadcn/components/ui/button";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "~/lib/shadcn/components/ui/collapsible";
import { Popover, PopoverContent, PopoverTrigger } from "~/lib/shadcn/components/ui/popover";
import { Separator } from "~/lib/shadcn/components/ui/separator";

export function Section13({ panels }: Section13Block) {
	const panelMarkup = panels.map((panel) => {
		return (
			<div className="flex flex-1 flex-col gap-3 min-w-80 basis-1/4" key={panel.id}>
				<Separator className="bg-black" />
				<h2 className="!mb-0 text-center !font-skia tracking-widest">{panel.heading}</h2>
				<Separator className="bg-black" />
				<div className="my-4 text-center">
					<h3 className="!mb-0 !font-sans !text-3xl">
						{panel.title} <span className="text-base">{panel.nextToTitle}</span>
					</h3>
					<h4 className="text-sm whitespace-pre-wrap" dangerouslySetInnerHTML={{ __html: panel.byline ?? "" }} />
				</div>
				<Separator className="bg-black" />
				<ul className="flex-1 list-outside ml-4 text-black list-disc my-4">
					{panel.items?.map((item) => {
						return (
							<li className="items-center mb-2 gap-2" key={item.id}>
								{item.label}{" "}
								{item.description && (
									<Popover>
										<PopoverTrigger>
											<CircleHelp className="ml-1 mt-0 translate-y-[0.1rem]" size="1rem" />
										</PopoverTrigger>
										<PopoverContent>
											<p>{item.description}</p>
										</PopoverContent>
									</Popover>
								)}
							</li>
						);
					})}
				</ul>
				{panel.moreDetails && (
					<Collapsible>
						<CollapsibleTrigger asChild>
							<Button className="w-full" variant={"dg-primary"}>
								More Details
							</Button>
						</CollapsibleTrigger>
						<CollapsibleContent className="py-4">
							<RichText className="flex flex-col gap-2 *:!font-sans [&_h2]:my-2 [&_p]:!mt-0" data={panel.moreDetails} />
						</CollapsibleContent>
					</Collapsible>
				)}
				<Button asChild className="w-full" variant={"dg-secondary"}>
					<Link href={panel.link!}>Purchase</Link>
				</Button>
			</div>
		);
	});
	return (
		<>
			<section className="dg-section pt-8 md:pt-0 px-8 md:px-20 relative w-full max-w-screen-xl mx-auto">
				<div className="basis-full mb-8 md:mb-16">
					<h2 className="tracking-widest">FOUNDING MEMBER BENEFITS</h2>
					<p>
						The first 20 villa members receive a one night upgrade to the owners residence valued at $25,000 (subject to
						availability).
						<br />
						Founding Villa memberships with these discounts and benefits are limited to 100 only.
					</p>
				</div>
				<div className="flex flex-wrap gap-16 md:gap-32">{panelMarkup}</div>
			</section>
		</>
	);
}
